// @ts-nocheck
import Tab from "@insite/mobius/Tab";
import TabGroup from "@insite/mobius/TabGroup";
import Typography from "@insite/mobius/Typography";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";

const StyleguideTabs: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Tabs" sectionId={sectionId}>
            <TabGroup>
                <Tab headline="Lorem Ipsum" tabKey="0">
                    <Typography as="p">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id lectus vel diam ornare
                        sagittis. Suspendisse non urna ut massa hendrerit condimentum volutpat sit amet velit. Morbi non
                        quam sit amet massa condimentum congue ac et dolor. Donec vitae enim ut diam varius cursus et
                        eget nibh. Etiam id sollicitudin libero. Vivamus orci orci, congue commodo finibus id, placerat
                        non sapien. Morbi pulvinar enim sed ullamcorper volutpat. Suspendisse potenti. Cras egestas
                        blandit eros. Donec imperdiet commodo feugiat. Suspendisse euismod libero ac massa varius
                        sollicitudin.
                    </Typography>
                </Tab>
                <Tab headline="Dolor" tabKey="1">
                    <Typography as="p">
                        Sed nisi dui, bibendum vitae metus a, cursus elementum mauris. Nunc lobortis facilisis est vitae
                        porta. Nullam a metus sed nisl maximus hendrerit. Praesent a sapien nec mauris sagittis sodales
                        sed et tortor. Morbi sit amet magna massa. Quisque vel vestibulum ipsum.
                    </Typography>
                </Tab>
                <Tab headline="Sit Amet" tabKey="2">
                    <Typography as="p">
                        Integer massa tortor, ultricies ullamcorper ante id, interdum fringilla ante. Phasellus maximus
                        nisl nisl, eget fringilla mi hendrerit ac. Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit.
                    </Typography>
                </Tab>
            </TabGroup>
        </StyleguideSection>
    );
};

export default StyleguideTabs;
